declare const __SELLAR_BUILD__: {
  version: string;
  commit: string;
  builtAt: string;
  release: string;
} | null;

export const frontendBuild = __SELLAR_BUILD__;

export const frontendVersionHeaders: Record<string, string> = frontendBuild
  ? {
      "x-sellar-client-version": `${frontendBuild.version}+${frontendBuild.commit}`,
    }
  : {};
